class PopUpController {
    constructor() {
      this.name = 'pop-up';
    }
  }
  
export default PopUpController;


// WEBPACK FOOTER //
// ./client/app/components/pop-up/pop-up.controller.js